import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import moment from 'moment';
import { StripeCapitalAutoLaunch } from 'slickpay/capital/StripeCapitalAutoLaunch.component';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import { fromPathnameToIsMonthlyDashboard, fromPathnameToNotBuckets, fromPathnameToNotDashboard, fromPathnameToNotMonthlyDashboard } from 'bl/pathname.bl';
import { withTranslation } from 'providers/GILT.provider';

import {
  getActualSalesData,
  getAllCommissionReport,
  getAppointmentsReport,
  getDailyRebookingReport,
  getForecastRevenue,
  getGlobalDiscount,
  getMonthlyRevenue,
  getNewClients,
  getProductSales,
  getProductSalesByStylist,
  getRebookingReport,
  getSalesDiscountsReport,
  getSalesReport,
  getSalonHoursReport,
  getStylistPerformedategories,
  getStylistsRequests,
  getUniqueClients,
  getUniqueVisits,
  getVisitFrequency,
  setDatePickerDate,
  setMonthlyDatePickerDate,
  setSalonVatRate,
  setStylistIDOrder,
} from 'reports/actions';
import BookingsLayout from 'reports/BookingsReport/BookingsLayout';
import BucketsReportsLayout from 'reports/BucketsReports/BucketsReportsLayout';
import CommissionsLayout from 'reports/Commissions/CommissionsLayout';
import DateRangePicker from 'reports/Common/DateRangePicker';
import MonthlyRangePicker from 'reports/Common/MonthlyRangePicker';
import DashboardReportsLayout from 'reports/DashboardReports/DashboardReportsLayout';
import MonthlyDashboardReportsLayout from 'reports/DashboardReports/MonthlyDashboardReports';
import DownloadableReportsLayout from 'reports/DownloadableReports/DownloadableReportsLayout';
import FutureRevenueLayout from 'reports/FutureRevenue/FutureRevenueLayout';
import HoursWorkedReportsContainer from 'reports/HoursWorked/HoursWorkedReports';
import PaymentsLayout from 'reports/Payments/PaymentsLayout';
import ReportsMenu from 'reports/ReportsMenu';
import { ReportsVATInput } from 'reports/ReportsVATInput';
import RetailLayoutContainer from 'reports/RetailReport/RetailLayout';
import RevenueReports from 'reports/RevenueTables/RevenueReports';
import ServicesLayout from 'reports/ServicesReport/ServicesLayout';

import 'styles/reports/pages.scss';
import 'styles/reports/print.scss';
import 'styles/reports/range-picker.scss';
import 'styles/reports/reports-bucket.scss';
import 'styles/reports/reports-tooltip.scss';

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.dateRangeRef = React.createRef();
    this.state = {
      inputHasVal: false,
      fromDateChanged: false,
      unmount: true,
      isMonthly: false,
      loadReportCalled: false,
      swapToEnd: false,
    };
  }

  UNSAFE_componentWillMount() {
    const { lastDatesSelected, stylists, salonId, location, isFetching, salesReport, getStylists } = this.props;
    const { unmount } = this.state;

    if (Math.round(moment.duration(lastDatesSelected.toDate.diff(lastDatesSelected.fromDate)).as('days')) !== 7) {
      setDatePickerDate(moment(lastDatesSelected.fromDate).startOf('week'), moment(lastDatesSelected.fromDate).endOf('week'));
    }

    if (stylists.length === 0) {
      getStylists(salonId);
    } else {
      if (fromPathnameToNotMonthlyDashboard(location?.pathname) && !isFetching && (!salesReport.lastRequestRespons || unmount)) {
        this.loadReports(lastDatesSelected, stylists);
        this.setState({ unmount: false });
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { salesReport, lastDatesSelected, stylists, location, setSalonVatRate } = this.props;
    const { loadReportCalled, fromDateChanged } = this.state;

    const pathnameNext = nextProps.location?.pathname;
    const pathnamePrev = location?.pathname;

    const picker = document.getElementById('report-pickers');

    if (picker) picker.style.display = fromPathnameToNotBuckets(pathnameNext) ? 'block' : 'none';

    if (fromPathnameToIsMonthlyDashboard(pathnameNext)) {
      this.setState({ isMonthly: true, loadReportCalled: false });
      setSalonVatRate(20);
    } else {
      this.setState({ isMonthly: false });
    }

    if (fromPathnameToNotMonthlyDashboard(pathnameNext) && nextProps.stylists.length > 0 && !salesReport.lastRequestRespons && !loadReportCalled) {
      this.loadReports(nextProps.lastDatesSelected, nextProps.stylists);
      this.setState({ loadReportCalled: true });
    }

    if (
      !fromDateChanged &&
      fromPathnameToNotBuckets(pathnameNext) &&
      fromPathnameToNotDashboard(pathnameNext) &&
      lastDatesSelected.fromDate.toISOString().indexOf('00:00.000Z') > 0 &&
      nextProps.lastDatesSelected.fromDate.toISOString() !== lastDatesSelected.fromDate.toISOString()
    ) {
      this.setState({ fromDateChanged: true });
      // when not dashboard, show toDate calendar if fromDate changed
      this.dateRangeRef?.current?.setState?.({ rangePicker: 'end' });
      this.setState({ swapToEnd: true });
    } else {
      this.setState({ swapToEnd: false });
    }

    if (nextProps.stylists.length > 0 && !nextProps.isFetching) {
      if (
        (nextProps.lastDatesSelected.lastCalenderClicked === 'toDate' && fromDateChanged) ||
        nextProps.lastDatesSelected.toDate.toISOString() !== lastDatesSelected.toDate.toISOString() ||
        (stylists.length && nextProps.stylists.length !== stylists.length)
      ) {
        if (fromPathnameToNotMonthlyDashboard(pathnamePrev)) {
          this.loadReports(nextProps.lastDatesSelected, nextProps.stylists);
          this.setState({ fromDateChanged: false });
        }
      }
    }
  }

  componentWillUnmount() {
    const { setDatePickerDate } = this.props;

    setDatePickerDate(moment().startOf('week'), moment().endOf('week'));
  }

  onBlur = (e) => {
    const { setSalonVatRate } = this.props;

    const vat = e.currentTarget.value;
    window.salonVatRate = vat;
    setSalonVatRate(vat);

    this.setState({ inputHasVal: Number(vat) !== 0 });
  };

  setSalonVatRate = (e) => {
    const { setSalonVatRate } = this.props;

    const vat = e.currentTarget.value;
    window.salonVatRate = vat;
    setSalonVatRate(vat);

    this.setState({ inputHasVal: Number(vat) !== 0 });
  };

  loadReports(nextLastDatesSelected, stylists) {
    const {
      salonId,
      lastDatesSelected,
      lastMonthlyDatesSelected,
      getStylistPerformedategories,
      getForecastRevenue,
      getActualSalesData,
      getMonthlyRevenue,
      setStylistIDOrder,
      getSalesReport,
      getSalesDiscountsReport,
      getNewClients,
      getDailyRebookingReport,
      getAppointmentsReport,
      getUniqueClients,
      getUniqueVisits,
      getSalonHoursReport,
      getRebookingReport,
      getVisitFrequency,
      getStylistsRequests,
      getProductSales,
      getProductSalesByStylist,
      getAllCommissionReport,
    } = this.props;

    const datesToUse = nextLastDatesSelected || lastDatesSelected;
    const montlyDatesToUse = lastMonthlyDatesSelected;

    if (!datesToUse.toDate) {
      return;
    }

    getStylistPerformedategories(salonId, datesToUse.fromDate, datesToUse.toDate);
    getForecastRevenue(salonId, datesToUse.fromDate, datesToUse.toDate);
    getActualSalesData(salonId, datesToUse.fromDate, datesToUse.toDate);

    if (montlyDatesToUse) {
      getMonthlyRevenue(salonId, montlyDatesToUse.fromDate, montlyDatesToUse.toDate);
    }

    if (stylists.length > 0) {
      const activeStylists = stylists.filter((s) => s.status === 'active' && s.status !== 'deleted');

      setStylistIDOrder(activeStylists);
      getSalesReport(salonId, datesToUse.fromDate, datesToUse.toDate, true, stylists);
      getSalesDiscountsReport(salonId, datesToUse.fromDate, datesToUse.toDate, stylists);
      getNewClients(salonId, datesToUse.fromDate, datesToUse.toDate, stylists);
    }

    getDailyRebookingReport(salonId, datesToUse.fromDate, datesToUse.toDate);
    getAppointmentsReport(salonId, datesToUse.fromDate, datesToUse.toDate);
    getUniqueClients(salonId, datesToUse.fromDate, datesToUse.toDate);
    getUniqueVisits(salonId, datesToUse.fromDate, datesToUse.toDate);
    getSalonHoursReport(salonId, datesToUse.fromDate, datesToUse.toDate);
    getRebookingReport(salonId, datesToUse.fromDate, datesToUse.toDate);
    getVisitFrequency(salonId, datesToUse.fromDate, datesToUse.toDate);
    getStylistsRequests(salonId, datesToUse.fromDate, datesToUse.toDate);
    getProductSales(salonId, datesToUse.fromDate, datesToUse.toDate);
    getProductSalesByStylist(salonId, datesToUse.fromDate, datesToUse.toDate);
    getAllCommissionReport(salonId);
  }

  render() {
    const { location, salonId, calendarMode, setMonthlyDatePickerDate, setDatePickerDate, lastMonthlyDatesSelected, monthlyRevenueReport, isFetching, lastDatesSelected, salonVatRate, t } = this.props;

    const { inputHasVal, isMonthly } = this.state;

    const pathname = location.pathname;

    const vatClass = fromPathnameToNotMonthlyDashboard(pathname)
      ? inputHasVal
        ? 'vat-container'
        : 'vat-container bgr-color'
      : inputHasVal
        ? 'vat-container invisible'
        : 'vat-container bgr-color invisible';

    return (
      <div className={`settings reports ${calendarMode === 'light' ? 'light-class' : calendarMode === 'dark' ? 'dark-class' : 'bright-class'}`}>
        <StripeCapitalAutoLaunch />
        <ReportsMenu salonId={salonId} />

        <div className={inputHasVal ? 'move-down' : 'move-up'}>
          <div className="sticky-nav" id="report-pickers">
            <div className="second-nav">
              {isFetching && (
                <div className="spinner-container">
                  <div className="load-spinner" />
                  <span className="spinner-text">{t('businessReports.loadingDatePickers')}</span>
                </div>
              )}
              {isMonthly ? (
                <MonthlyRangePicker
                  setMonthlyDatePickerDate={setMonthlyDatePickerDate}
                  lastMonthlyDatesSelected={lastMonthlyDatesSelected}
                  monthlyRevenueReport={monthlyRevenueReport}
                  location={location}
                  ref={this.dateRangeRef}
                  isFetching={isFetching}
                />
              ) : (
                <DateRangePicker
                  tag="Reports__range-picker"
                  onChangeDate={setDatePickerDate}
                  lastDatesSelected={lastDatesSelected}
                  location={location}
                  swapToEnd={this.state.swapToEnd}
                  isFetching={isFetching}
                />
              )}
              <ReportsVATInput
                className={vatClass}
                label={t('businessReports.vatRateLabel')}
                value={salonVatRate}
                placeholder={t('businessReports.vatRatePlaceholder')}
                onBlur={this.onBlur}
                onChange={this.setSalonVatRate}
              />
              {inputHasVal ? (
                <div className="vat-info-banner">
                  <span>{t('businessReports.vatInfoBanner')}</span>
                </div>
              ) : null}
            </div>
          </div>

          <Switch>
            <Route exact path="/salon/:id/reports" />
            <Route path="/salon/:id/reports/buckets" component={BucketsReportsLayout} />
            <Route path="/salon/:id/reports/dashboard" component={DashboardReportsLayout} />
            <Route path="/salon/:id/reports/monthly-dashboard" component={MonthlyDashboardReportsLayout} />
            <Route path="/salon/:id/reports/services" component={ServicesLayout} />
            <Route path="/salon/:id/reports/revenue*" component={RevenueReports} />
            <Route path="/salon/:id/reports/future-revenue" component={FutureRevenueLayout} />
            <Route path="/salon/:id/reports/retail" component={RetailLayoutContainer} />
            <Route path="/salon/:id/reports/commissions*" component={CommissionsLayout} />
            <Route path="/salon/:id/reports/payments*" component={PaymentsLayout} />
            <Route path="/salon/:id/reports/hours*" component={HoursWorkedReportsContainer} />
            <Route path="/salon/:id/reports/bookings*" component={BookingsLayout} />
            <Route path="/salon/:id/reports/downloadable" component={DownloadableReportsLayout} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state?.currentSalon?.id,
  calendarMode: state?.currentSalon?.calendar_mode,
  stylists: state?.onboarding?.stylists?.stylists,
  lastDatesSelected: state?.reports?.lastDatesSelected,
  lastMonthlyDatesSelected: state?.reports?.lastMonthlyDatesSelected,
  salesReport: state?.reports?.salesReport,
  salonVatRate: state?.reports?.salonVatRate,
  isFetching: state?.reports?.isFetching,
  monthlyRevenueReport: state?.reports?.monthlyRevenueReport,
});

export function mapDispatchToProps(dispatch) {
  return {
    setDatePickerDate(startDate, endDate) {
      dispatch(setDatePickerDate(startDate, endDate));
    },
    getGlobalDiscount(salonId) {
      dispatch(getGlobalDiscount(salonId));
    },
    getForecastRevenue(salonId, startDate, endDate) {
      dispatch(getForecastRevenue(salonId, startDate, endDate));
    },
    getActualSalesData(salonId, startDate, endDate) {
      dispatch(getActualSalesData(salonId, startDate, endDate));
    },
    getUniqueClients(salonId, startDate, endDate) {
      dispatch(getUniqueClients(salonId, startDate, endDate));
    },
    getUniqueVisits(salonId, startDate, endDate) {
      dispatch(getUniqueVisits(salonId, startDate, endDate));
    },
    getVisitFrequency(salonId, startDate, endDate) {
      dispatch(getVisitFrequency(salonId, startDate, endDate));
    },
    getSalesReport(salonId, startDate, endDate, mutateDate, stylists) {
      dispatch(getSalesReport(salonId, startDate, endDate, mutateDate, stylists));
    },
    getSalesDiscountsReport(salonId, startDate, endDate, stylists) {
      dispatch(getSalesDiscountsReport(salonId, startDate, endDate, stylists));
    },
    getDailyRebookingReport(salonId, startDate, endDate, mutateDate) {
      dispatch(getDailyRebookingReport(salonId, startDate, endDate, mutateDate));
    },
    getAppointmentsReport(salonId, startDate, endDate, mutateDate = true) {
      dispatch(getAppointmentsReport(salonId, startDate, endDate, mutateDate));
    },
    getRebookingReport(salonId, startDate, endDate, mutateDate = true) {
      dispatch(getRebookingReport(salonId, startDate, endDate, mutateDate));
    },
    getSalonHoursReport(salonId, startDate, endDate, mutateDate) {
      dispatch(getSalonHoursReport(salonId, startDate, endDate, mutateDate));
    },
    getStylists(salonId) {
      dispatch(fetchStylistsBySalon(salonId));
    },
    getStylistsRequests(salonId, startDate, endDate) {
      dispatch(getStylistsRequests(salonId, startDate, endDate));
    },
    setSalonVatRate(vat) {
      dispatch(setSalonVatRate(vat));
    },
    getNewClients(salonId, startDate, endDate, stylists) {
      dispatch(getNewClients(salonId, startDate, endDate, stylists));
    },
    setStylistIDOrder(IDs) {
      dispatch(setStylistIDOrder(IDs));
    },
    getProductSales(salonId, startDate, endDate) {
      dispatch(getProductSales(salonId, startDate, endDate));
    },
    getProductSalesByStylist(salonId, startDate, endDate) {
      dispatch(getProductSalesByStylist(salonId, startDate, endDate));
    },
    getStylistPerformedategories(salonId, startDate, endDate) {
      dispatch(getStylistPerformedategories(salonId, startDate, endDate));
    },
    getAllCommissionReport(salonId) {
      dispatch(getAllCommissionReport(salonId));
    },
    setMonthlyDatePickerDate(startDate, endDate, isFromDate) {
      dispatch(setMonthlyDatePickerDate(startDate, endDate, isFromDate));
    },
    getMonthlyRevenue(salonId, startDate, endDate) {
      dispatch(getMonthlyRevenue(salonId, startDate, endDate));
    },
  };
}

const ReportsHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Reports));

export default ReportsHoc;
